export default {
  nothing_found: "Oops. Nothing here...",
}
